"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_STORAGE = exports.FILES_STORAGE = exports.LEAD_STORAGE = void 0;
exports.LEAD_STORAGE = 'lead-storage';
exports.FILES_STORAGE = 'files';
exports.APP_STORAGE = 'app';
